export const attachmentKeys = {
  embeddedVideo: (url: string) => ['embedded-video', url] as const,
}
